import { BsBuildings, BsPersonPlus, BsShieldLock, BsTags } from "react-icons/bs";
import { HiOutlineUsers } from "react-icons/hi";

// Setup modules shown as cards on the setup home page and in the setup nav bar
export const sections = [
  {
    title: "Create New User",
    description: "Invite a new team member and give them access to Campus Pulse.",
    to: "/customer/registerAdmin",
    permission: "create-user",
    icon: BsPersonPlus,
    accent: "from-[#023f88] to-[#0b5cae]",
    group: "People",
  },
  {
    title: "Users List",
    description: "Browse, search and manage every user account in one place.",
    to: "/admin/setup/staffs",
    permission: "readAll-user",
    icon: HiOutlineUsers,
    accent: "from-sky-500 to-blue-600",
    group: "People",
  },
  {
    title: "Roles & Permissions",
    description: "Define roles and control exactly what each one can do.",
    to: "/admin/setup/role",
    permission: "readAll-role",
    icon: BsShieldLock,
    accent: "from-violet-500 to-purple-600",
    group: "Access",
  },
  {
    title: "Departments",
    description: "Organise your users into departments and teams.",
    to: "/admin/setup/department",
    permission: "readAll-department",
    icon: BsBuildings,
    accent: "from-amber-500 to-orange-500",
    group: "Organisation",
  },
  {
    title: "Post Categories",
    description: "Set up the categories used to classify posts across the feed.",
    to: "/admin/setup/ticket-category",
    permission: "readAll-ticketCategory",
    icon: BsTags,
    accent: "from-rose-500 to-pink-600",
    group: "Content",
  },
];
